/**
 * ActionRow — кликабельная строка списка: значок-кружок + заголовок + подзаголовок + хвост.
 * tone: "default" — нейтральная; "warn" — янтарная (требует действия). trailing по умолчанию «›».
 */
import type { ReactNode } from "react";

type Tone = "default" | "warn";
type Surface = "card" | "glass";

export function ActionRow({
  icon,
  iconClass = "bg-white/10",
  title,
  subtitle,
  onClick,
  trailing,
  tone = "default",
  surface = "card",
}: {
  icon: ReactNode;
  iconClass?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  onClick: () => void;
  trailing?: ReactNode;
  tone?: Tone;
  surface?: Surface;
}) {
  const row =
    tone === "warn"
      ? "bg-amber-400/10"
      : surface === "glass"
      ? "border border-white/[0.08] bg-white/[0.04] backdrop-blur-xl"
      : "bg-surface-card";
  const titleCls = tone === "warn" ? "text-amber-300" : "text-white";
  return (
    <button
      onClick={onClick}
      className={`flex w-full items-center gap-3 rounded-2xl ${row} px-4 py-3 text-left active:opacity-70`}
    >
      <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full text-[18px] ${iconClass}`}>{icon}</span>
      <div className="min-w-0 flex-1">
        <div className={`truncate text-[15px] font-medium ${titleCls}`}>{title}</div>
        {subtitle && <div className="truncate text-[12px] text-white/45">{subtitle}</div>}
      </div>
      {trailing ?? <span className="shrink-0 text-white/30">›</span>}
    </button>
  );
}
